module.exports = __webpack_public_path__ + "img/animals_04_H.8eca8f24.webp";